// import { ref } from "vue";

// export default function useExpandable() {
//   const isExpanded = ref(false);
//   const contentRef = ref(null);

//   const toggleExpand = () => {
//     isExpanded.value = !isExpanded.value;

//     // Adjusting the height dynamically for smooth transitions
//     if (isExpanded.value && contentRef.value) {
//       contentRef.value.style.maxHeight = `${contentRef.value.scrollHeight}px`;
//     } else if (contentRef.value) {
//       contentRef.value.style.maxHeight = null;
//     }
//   };

//   return { isExpanded, contentRef, toggleExpand };
// }

import { ref, watch } from "vue";

export default function useExpandable(initialState = false) {
  const isExpanded = ref(initialState);
  const contentRef = ref(null);

  const setMaxHeight = () => {
    if (contentRef.value) {
      contentRef.value.style.maxHeight = isExpanded.value
        ? `${contentRef.value.scrollHeight}px`
        : "0px";
    }
  };

  const toggleExpand = () => {
    isExpanded.value = !isExpanded.value;
    setMaxHeight();
  };

  // Watch for changes in isExpanded and adjust maxHeight accordingly
  watch(isExpanded, () => {
    setMaxHeight();
  });

  return { isExpanded, contentRef, toggleExpand };
}
